export default {
  namespaced: true,
  state: {
    list: [],
    /** 增加已读和未读,在来一个param的参数 */
    /*  param里面的参数
      inquiryId
      inquiryUser
      Model
    */
  },
  mutations: {
    changeHadRead(state,{ inquiryId, }){
      const find = state.list.find(i=>i.inquiryId === inquiryId)
      if(find) find.hadRead = true
    },
    unshiftList(state,{ inquiryId, inquiryUser, Model, }){
      state.list.unshift({
        hadRead: false,
        inquiryId,
        inquiryUser,
        Model,
      })
    },
  },
  actions: {},
  getters: {},
}